import { useState } from 'react';
import Navbar from '../components/Navbar';
import Dashboard from './Dashboard';
import EquiposScreen from './EquiposScreen';
import AreasScreen from './AreasScreen';
import UsuariosScreen from './UsuariosScreen';
import AsignacionesScreen from './AsignacionesScreen';
import TarjetasScreen from './TarjetasScreen';
import SucursalesScreen from './SucursalesScreen';
import CelularesScreen from './CelularesScreen';

export default function MainApp({ currentUser, token, onLogout }) {
  const [pantalla, setPantalla] = useState('dashboard');

  return (
    <div>
      <Navbar currentUser={currentUser} logout={onLogout} pantalla={pantalla} setPantalla={setPantalla} token={token}/>
      {pantalla === 'dashboard' && <Dashboard currentUser={currentUser} token={token} />}
      {pantalla === 'equipos' && <EquiposScreen currentUser={currentUser} token={token} />}
      {pantalla === 'sucursales' && <SucursalesScreen currentUser={currentUser} token={token} />}
      {pantalla === 'areas' && <AreasScreen token={token}/>}
      {pantalla === 'usuarios' && <UsuariosScreen currentUser={currentUser} token={token} />}
      {pantalla === 'celulares' && <CelularesScreen currentUser={currentUser} token={token} />}
      {pantalla === 'asignaciones' && <AsignacionesScreen currentUser={currentUser} token={token} />}
      {pantalla === 'tarjetas' && <TarjetasScreen currentUser={currentUser} token={token} />}
    </div>
  );
}
